import FavoriteProductGrid from "./favorite-product-grid";

export default FavoriteProductGrid;